module.exports = __webpack_public_path__ + "static/media/charity.95076fd3.svg";